import * as React from "react";

import { AppLoading } from "./app-loading";
import { PageWideAnalytics } from "./page-wide-analytics";
import { PdpDrawer } from "./pdp-drawer";
import { UpsellProduct } from "./upsell-product";

export interface PDPInitialStateProps {
  productId: string;
  is_fh_container: 0 | 1;
}

export interface PDPInitialStateProviderProps {
  useInitialState: () => {
    initialState: PDPInitialStateProps;
  };
}
export const Page = ({ useInitialState }: PDPInitialStateProviderProps) => {
  const { initialState } = useInitialState();
  const isFHContainerActive = initialState.is_fh_container === 1;
  const productId = initialState.productId;

  return (
    <div className="bbnt-react-pdp-page">
      <AppLoading />

      <PageWideAnalytics />
      {isFHContainerActive && <UpsellProduct productId={productId} />}
      <PdpDrawer />
    </div>
  );
};
